import styles from "./SectionIntro.module.css";

export default function SectionIntro({ label, title, description, className }) {
  return (
    <div className={[styles.intro, className].filter(Boolean).join(" ")}>
      {label ? <p className={styles.label}>{label}</p> : null}
      {title ? <h2 className={styles.title}>{title}</h2> : null}
      {description ? <p className={styles.description}>{description}</p> : null}
    </div>
  );
}
